import * as yup from 'yup';

export const emergencyContactsSchema = yup.object().shape({
	contacts: yup.array().of(
		yup.object().shape({
			contactName: yup.string().required('Name is required.'),
			relationship: yup.string().required('Relationship is required.'),
			cellPhone: yup.string().required('Cell Phone is required.'),
			officePhone: yup.string(),
		})
	),
});
